import axios from 'axios'
import config from '@/config'

export default {
  state: {
    userInfoData: [],
    recovery_pass_data: [],
    isAuth: false,
  },
  mutations: {
    loginUserData: (state, response) => state.userInfoData = response,
    RecoveryPassData: (state, response) => state.recovery_pass_data  = response,
    setAuth: (state, flag) => state.isAuth = flag,
  },
  actions: {
    async login(ctx, loginData ){
      await axios.post(
        `${config.API_URL}/api/rest/receipt/kabinet_ident`,
        loginData,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          }
        },
        
      ).then((response) => {
        if(!response.data.items[0].err) {
          const timeAlive = (+response.data.items[0].tokenTimeAlive * 1000 * 10) - 10000
          localStorage.setItem('weltumKey', response.data.items[0].secret_key)
          localStorage.setItem('weltumTimeAuth', Date.now())
          localStorage.setItem('weltumtokenTimeAlive', timeAlive)
          localStorage.setItem('weltumAuth', loginData.login) 
          localStorage.setItem('weltum_user_fio', response.data.items[0].fio) 
          localStorage.setItem('weltum_user_tel', response.data.items[0].tel) 
          localStorage.setItem('weltum_user_mail', response.data.items[0].mail)   
        }
        ctx.commit('loginUserData', response.data)
        ctx.commit('setAuth', true)
      })

    },
    async RecoveryPass(ctx, recovery_data ){
      await axios.post(
        `${config.API_URL}/api/rest/receipt/recovery_password`,
        recovery_data,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          }
        },
        
      ).then((response) => {
        ctx.commit('RecoveryPassData', response.data)
      })

    }
  },
  getters:{
    userInfoData: s => s.userInfoData,
    recoveryPassData: s => s.recovery_pass_data,
    isAuth: s => s.isAuth,
  },
}